module.exports = __webpack_public_path__ + "static/img/bottom_left_light.5311143a.png";